<template>
  <div class="main-table">
    <div class="slot-row" v-if="columnDatas.showDelete">
      <div style="padding: 10px 0px">已选{{ checkboxData.length }}个</div>
    </div>
    <el-table
      :show-summary="columnDatas.showSum"
      :row-key="columnDatas.hasRowKey ? setRowKey : ''"
      :span-method="spanMethod"
      :data="tableData"
      ref="mainTable"
      @row-click="checkRow"
      @selection-change="setcheckRows"
      border
    >
      <el-table-column
        v-if="columnDatas.showSelect"
        :reserve-selection="columnDatas.hasRowKey"
        :fixed="columnDatas.selectFixed"
        :selectable="columnDatas.selectable"
        type="selection"
        width="50"
      ></el-table-column>
      <el-table-column
        v-if="columnDatas.showIndex"
        label="序号"
        type="index"
        width="50"
      ></el-table-column>
      <el-table-column
        v-if="columnDatas.showExpand && !columnDatas.expandAfter"
        label="详情"
        type="expand"
      >
        <template slot-scope="props">
          <slot :data="props.row"></slot>
        </template>
      </el-table-column>
      <template v-if="columnDatas.noSum">
        <el-table-column
          v-for="(item, index) in columnDatas.columns"
          v-if="!item.render"
          :key="index"
          :label="item.label"
          :width="item.width"
          :fixed="item.fixed"
          :show-overflow-tooltip="true"
        >
          <span v-if="!item.children" slot-scope="scope">{{
            scope.row[item.prop]
          }}</span>
          <el-table-column
            v-for="(citem, cindex) in item.children"
            v-if="item.children"
            :key="cindex"
            :label="citem.label"
            :width="citem.width"
            :fixed="citem.fixed"
            :show-overflow-tooltip="true"
          >
            <span slot-scope="scope">{{ scope.row[citem.prop] }}</span>
          </el-table-column>
        </el-table-column>
        <el-table-column
          :label="item.label"
          v-else
          :key="index"
          :width="item.width"
          :fixed="item.fixed"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <table-cell
              :row="scope.row"
              :index="scope.$index"
              :render="item.render"
            ></table-cell>
          </template>
        </el-table-column>
      </template>
      <template v-if="!columnDatas.noSum">
        <el-table-column
          v-for="(item, index) in columnDatas.columns"
          v-if="!item.render && !item.hidden"
          :key="index"
          :label="item.label"
          :width="item.width"
          :fixed="item.fixed"
        >
          <el-table-column
            v-if="!item.children"
            :width="item.width"
            :label="
              index === 0
                ? '合计'
                : item.sumprop && sumsData[item.sumprop]
                ? sumsData[item.sumprop] + ''
                : ''
            "
            :class-name="item.sumprop || index === 0 ? 'hassum' : ''"
            :show-overflow-tooltip="true"
          >
            <span slot-scope="scope">{{ scope.row[item.prop] }}</span>
          </el-table-column>
          <el-table-column
            v-for="(citem, cindex) in item.children"
            v-if="item.children"
            :key="cindex"
            :label="citem.label"
            :width="citem.width"
            :fixed="citem.fixed"
          >
            <el-table-column
              v-if="!citem.children"
              :width="item.width"
              :label="
                citem.sumprop && sumsData[citem.sumprop]
                  ? sumsData[citem.sumprop] + ''
                  : ''
              "
              :class-name="citem.sumprop ? 'hassum' : ''"
              :show-overflow-tooltip="true"
            >
              <span slot-scope="scope">{{ scope.row[citem.prop] }}</span>
            </el-table-column>
          </el-table-column>
        </el-table-column>
        <el-table-column
          :label="item.label"
          v-else-if="item.render && !item.hidden"
          :key="index"
          :width="item.width"
          :fixed="item.fixed"
        >
          <el-table-column
            v-if="!item.children"
            :width="item.width"
            :label="
              index === 0
                ? '合计'
                : item.sumprop && sumsData[item.sumprop]
                ? sumsData[item.sumprop] + ''
                : ''
            "
            :class-name="item.sumprop || index === 0 ? 'hassum' : ''"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <table-cell
                :row="scope.row"
                :index="scope.$index"
                :render="item.render"
              ></table-cell>
            </template>
          </el-table-column>
        </el-table-column>
      </template>
      <el-table-column
        v-if="columnDatas.showExpand && columnDatas.expandAfter"
        label="详情"
        type="expand"
      >
        <template slot-scope="props">
          <slot :data="props.row"></slot>
        </template>
      </el-table-column>
    </el-table>
    <slot name="pages"></slot>
    <div v-if="columnDatas.showDelete">
      <span style="padding-right: 10px">已选{{ checkboxData.length }}个</span>
      <el-button size="mini" type="primary" @click="deleteRows"
        >批量删除</el-button
      >
    </div>
  </div>
</template>

<script>
import TableCell from "./table-cell"; // 动态渲染用js
export default {
  name: "data-table",
  components: {
    TableCell,
  },
  props: {
    spanMethod: {
      type: Function,
      default: () => {
        return () => {};
      },
    },
    onlyId: {
      type: String,
      default: () => {
        return "guid";
      },
    },
    sumsData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 列表表头对象
    columnDatas: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 列表数据
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    setRowKey: {
      type: Function,
      default: () => {
        return () => {};
      },
    },
  },
  data() {
    return {
      selectRow: {}, // 当前选中行
      checkboxData: [],
      ajaxData: {},
    };
  },
  mounted() {
    this.columnDatas.columns.forEach((item) => {
      if (item.apiData && !item.apiData.await) {
        this.$set(this.ajaxData, item.apiData.apiname, []);
        this.$http(item.apiData.url, item.apiData.data, {
          ajaxType: "none",
        }).then((res) => {
          this.$set(
            this.ajaxData,
            item.apiData.apiname,
            Array.isArray(res.body) ? res.body : res.body.rows
          );
        });
      }
    });
  },
  methods: {
    // 设置当前选中行
    checkRow(row, event) {
      if (row.select) return;
      this.$emit("selectRow", row);
    },
    awaitAjax(data) {
      data.forEach((item) => {
        this.$set(this.ajaxData, item.apiname, []);
        this.$http(item.url, item.data, { ajaxType: "none" }).then((res) => {
          this.$set(
            this.ajaxData,
            item.apiname,
            Array.isArray(res.body) ? res.body : res.body.rows
          );
        });
      });
    },
    showError(mes) {
      this.$message({
        showClose: true,
        duration: 1000,
        message: mes,
      });
    },
    getSelectText(val, row, item) {
      if (item.apiData && item.apiData.listener) {
        this.$emit("selectChange", { row, item });
      }
      if (item.selectText) {
        row[item.selectText] = this.ajaxData[item.apiData.apiname].find(
          (row) => {
            return row[item.value] === val;
          }
        )[item.key];
        return;
      }
      row[item.selectText] = val;
    },
    // 批量删除
    deleteRows() {
      if (!this.checkboxData.length) {
        this.showError(`请选择需要删除的数据`);
        return;
      }
      this.$set(
        this.tableData,
        _.pullAll(this.tableData, this.checkboxData, this.onlyId)
      );
    },
    // 设置选中行
    setcheckRows(rows) {
      this.checkboxData = rows;
      this.$emit("checkRows", rows);
    },
  },
};
</script>

<style lang="stylus">
.clear {
  &:after, &:before {
    content: ' ';
    display: table;
  }

  &:after {
    clear: both;
  }
}

.iserror .isreq .el-input__inner, .numreq .el-input__inner {
  border-color: #f56c6c;
}

.main-table {
  padding: 20px;
  padding-top: 0;

  .el-pagination {
    text-align: right;
  }

  > div {
    margin-bottom: 32px;
  }

  .slot-row {
    @extend .clear;

    > div {
      float: left;
      margin-right: 15px;
    }
  }

  .el-table {
    thead th {
      background-color: #FAFAFA;
      color: #717171;

      .cell {
        word-break: break-word;
      }
    }

    th.hassum {
      vertical-align: bottom;
      padding-bottom: 10px;

      .cell {
        padding-bottom: 10px;
      }
    }

    .el-input {
      input {
        text-align: right;
      }
    }

    .el-select {
      input {
        text-align: left;
      }
    }

    input[type='checkbox'] {
      left: 0;
    }

    .el-checkbox__input.is-checked.is-focus .el-checkbox__inner {
      box-shadow: 0px 0px 0px 2px #95b1c5b0;
    }
  }

  .sum-row {
    span {
      padding-right: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/table/data-table.vue